/* Common Imports */

import { makeStyles } from "@material-ui/core/styles";
import React from "react";

/* Component Imports */

import FooterBody from "./footer-components/FooterBody";
import FooterContactLinks from "./footer-components/FooterContactLinks";
import FooterCopyrightInfo from "./footer-components/FooterCopyrightInfo";
import FooterSocialIcons from "./footer-components/FooterSocialIcons";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    padding: "0rem 0rem 0rem 0rem",
    backgroundColor: "#FAFAFA",
    boxShadow: "0px 3px 3px -2px rgb(0 0 0 / 20%), 0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%)",
    padding: "2.5rem 8rem 4rem 8rem",
    [theme.breakpoints.down("sm")]: {
      padding: "0rem 2rem 0rem 2rem",
    },
    [theme.breakpoints.down("xs")]: {
      padding: "0rem 1rem 0rem 1rem",
    },
    [theme.breakpoints.down("md")]: {
      padding: "0rem 2rem 0rem 2rem",
    },
  },
  footerRef: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  iconsAndCopyright: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "50%",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column-reverse",
      width: "100%",
    },
    [theme.breakpoints.up("lg")]: {
      width: "100%",
    },
  },
}));

const Footer = () => {
  const classes = useStyles();

  return (
    <React.Fragment>
      <div className={classes.root}>
        {/* <BeegruContainer> */}

        <FooterBody />
        <div className={classes.footerRef}>
          <FooterContactLinks />
          <div className={classes.iconsAndCopyright}>
            <FooterCopyrightInfo />
            <FooterSocialIcons />
          </div>
        </div>
      </div>
      {/* </BeegruContainer> */}
    </React.Fragment>
  );
};

export default Footer;
